import { EnquiryHandle } from '@access-erp/common';
import {
  ConfirmationModal,
  FlexProps,
  FormTextarea,
  IRowNode,
  ModalType,
} from '@access-erp/ui-components';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';

import { validationSchema } from './../validationSchema';
import styles from './confirmation-modal-body.module.scss';
import { CancelUpliftsInputType, PaginatedFilteredUpliftType } from '@/graphql/contracts/_generated_/contracts';
import { UpliftTypeWithId } from '@/utils/data-helpers/types';

interface CancelModalProps {
  isVisibleCancelUpliftModal: boolean;
  closeCancelUpliftModal: () => void;
  confirmCanceluplift: (upliftIdsAndReason: CancelUpliftsInputType, onSuccess: () => void) => void;
  selectedRows: IRowNode<PaginatedFilteredUpliftType>[];
  gridRef: React.RefObject<EnquiryHandle<UpliftTypeWithId>>;
}

function CancelUpliftModal({
  isVisibleCancelUpliftModal,
  closeCancelUpliftModal,
  confirmCanceluplift,
  selectedRows,
  gridRef,
}: CancelModalProps) {
  const methods = useForm({
    values: {
      reason: undefined,
    },
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const refreshAndReset = () => {
    gridRef?.current?.deselectRows();
    gridRef.current?.refreshServerSideGrid({
      purge: true,
    });
    closeCancelUpliftModal();
    methods.reset();
  };

  const handleConfirm = () => {
    const upliftIds: string[] = selectedRows
      .map(row => row.data?.iD)
      .filter((id): id is string => !!id);
    confirmCanceluplift(
      { uplifIds: upliftIds, reason: methods.getValues().reason ?? '' },
      refreshAndReset,
    );
  };

  const handleCancel = () => {
    closeCancelUpliftModal();
    methods.reset();
  };
  return (
    <ConfirmationModal
      open={isVisibleCancelUpliftModal}
      onClose={handleCancel}
      onConfirm={handleConfirm}
      confirmButtonText="Confirm"
      title="Do you want to cancel the selected Uplifts?"
      type={ModalType.Warning}
      footerAlign={FlexProps['space-between']}
      disableConfirmButton={!methods.formState.isValid}
    >
      <div className={styles.content}>
        The selected Pending Uplifts will be cancelled. To apply new values you will have to provide
        <br />
        them normally again. Please, provide the reason for the cancellation:
        <br />
        <br />
        <FormProvider {...methods}>
          <div className={styles['textbox-wrapper']}>
            <FormTextarea
              label=""
              name="reason"
              id="reason"
              required={true}
              onChange={(e) => {
                if ('value' in e) {
                  const value = e.value?.trim() ? e.value : undefined;
                  methods.setValue('reason', value, { shouldValidate: true });
                }
              }}
              resize="none"
              className={styles.textbox}
            />
          </div>
        </FormProvider>
      </div>
    </ConfirmationModal>
  );
}

export default CancelUpliftModal;
